import { InitClient, Post } from "../ZeusAPIClient.js";
import { apiConfig } from "../../config.js";
import { GetNewGuid } from "../Logic/HomeLogic";
import DispalyName from "../DisplayNameConfig/DispalyName";

InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);

async function EnqueueLog(log, newEntity, oldEntity, T) {
  var detail = await GetLogDetail(newEntity, oldEntity, log.ID, T);
  log.Zeus_LogDetails = detail;
  //console.log(detail.length);
  var data = await Post("feab76d1-db89-44b8-8eed-607bae4b8fde", log);
  data = data.replace('"', "");
  if (data == "success") {
    return true;
  } else {
    return false;
  }
}
//创建日志
//title 日志标题
//userid 操作人id
//userName操作人姓名
//operateType 操作类型
//logType 日志类型
//message 消息
//pkValue 唯一ID
async function CreateLog(
  title,
  userId,
  userName,
  operateType,
  logType,
  message,
  pkValue
) {
  var id = await GetNewGuid();
  //console.log(userName);
  var log = new Log(
    id,
    title,
    userId,
    userName,
    operateType,
    logType,
    message,
    pkValue
  );
  return log;
}
//生成日志详情
//newEntity 新实体
//oldEntity 旧实体
//logId 日志ID
//T 实体类型 通过实体类型从displayNameConfig中获取字段中文名称
async function GetLogDetail(newEntity, oldEntity, logId, T) {
  var keys = Reflect.ownKeys(newEntity);
  //获取实体的字段名称，newEntity一般要比oldEntity的字段要多
  var displayNameConfig = GetDisplayNameConfig(T); //根据实体类型获取对应的中文名称config，新的实体需要自行添加该config
  var detail = []; //日期
  if (displayNameConfig) {
    //如果能够获取中文名称才进行日志详情的生成
    for (let index = 0; index < keys.length; index++) {
      var id = await GetNewGuid();
      var name = Reflect.get(displayNameConfig, keys[index]); //获取字段中文名称
      var newValue = Reflect.get(newEntity, keys[index]); //获取新的实体中的字段值
      if (typeof newValue == "object") {
        //如果新的字段值还是object,递归获取
        if (!newValue instanceof Array) {
          var oldValue;
          if (!oldEntity) {

            oldValue = Reflect.get(oldEntity, keys[index]);

          } else {
            oldValue = null;
          }
          //detail.concat(GetLogDetail(newValue, oldValue, logId, T));
        }
      } else {
        if (name) {
          //只有中文名称存在的字段才会生成日志详情
          if (!oldEntity) {
            //如果旧的实体不存在，直接添加新的字段值
            var d = new LogDetail(id, logId, name, newValue, "");
            detail.push(d);
          } else {
            //如果旧的实体存在，对比新旧字段值，二者不同，生成日志详情
            var oldValue = Reflect.get(oldEntity, keys[index]);
            if (newValue != oldValue) {
              var d = new LogDetail(id, logId, name, newValue, oldValue);
              detail.push(d);
            }
          }
        }
      }
    }
  }
  return detail;
}
//T类型
function GetDisplayNameConfig(T) {
  switch (T) {
    case "financialTicket":
      return DispalyName.FinancialTicket;
      break;
    case "financialUser":
      return DispalyName.financialUser;
      break;
    case "sysUser":
      return DispalyName.sysUser;
      break;
    case "frameInfo":
      return DispalyName.frameInfo;
      break;
    case "userInfoModel":
      return DispalyName.userInfoModel;
      break;
    case 'userInfo':
      return DispalyName.userInfo;
      break;
    default:
      break;
  }
}
async function EnqueueFinancialLog(
  title,
  userId,
  userName,
  operateType,
  message,
  pkValue,
  newEntity,
  oldEntity,
  T
) {
  var log = await CreateLog(
    title,
    userId,
    userName,
    operateType,
    "财务系统",
    message,
    pkValue
  );
  //console.log(userId);
  EnqueueLog(log, newEntity, oldEntity, T);
}
//编辑员工档案
async function EnqueueFullUser(
  title,
  userId,
  userName,
  operateType,
  message,
  pkValue,
  newEntity,
  oldEntity,
  T
) {
  var log = await CreateLog(
    title,
    userId,
    userName,
    operateType,
    "员工档案",
    message,
    pkValue
  );
  EnqueueLog(log, newEntity, oldEntity, T);
}
//编辑部门信息
async function EnqueueFrame(
  title,
  userId,
  userName,
  operateType,
  message,
  pkValue,
  newEntity,
  oldEntity,
  T
) {
  var log = await CreateLog(
    title,
    userId,
    userName,
    operateType,
    "部门信息",
    message,
    pkValue
  );
  EnqueueLog(log, newEntity, oldEntity, T);
}
//编辑员工档案
async function SetFullUser(
  title,
  userId,
  userName,
  operateType,
  message,
  pkValue,
  newEntity,
  oldEntity,
  T
) {
  var log = await CreateLog(
    title,
    userId,
    userName,
    operateType,
    "发起入职",
    message,
    pkValue
  );
  EnqueueLog(log, newEntity, oldEntity, T);
}
async function EnqueueDelUser(
  title,
  userId,
  userName,
  operateType,
  message,
  pkValue,
  newEntity,
  oldEntity,
  T
) {
  var log = await CreateLog(
    title,
    userId,
    userName,
    operateType,
    "删除入职信息",
    message,
    pkValue
  );
  EnqueueLog(log, newEntity, oldEntity, T);
}
//离职添加日志
async function EnqueueUserLeave(
  title,
  userId,
  userName,
  operateType,
  message,
  pkValue,
  newEntity,
  oldEntity,
  T
) {
  var log = await CreateLog(
    title,
    userId,
    userName,
    operateType,
    "人力资源",
    message,
    pkValue
  );
  EnqueueLog(log, newEntity, oldEntity, T);
}




//日志类
//title 日志标题
//userid 操作人id
//userName操作人姓名
//operateType 操作类型
//logType 日志类型
//message 消息
//pkValue 唯一ID
class Log {
  constructor(
    Id,
    title,
    userId,
    userName,
    operateType,
    logType,
    message,
    pkValue
  ) {
    (this.ID = Id),
      (this.LogTitle = title),
      (this.LogType = logType),
      (this.LogTime = new Date()),
      (this.OperaorID = userId),
      (this.OperatorName = userName),
      (this.OperatorIP = window.location.host),
      (this.OperateType = operateType),
      (this.LogMessage = message),
      (this.PKValue = pkValue);
  }
}
//日志详情类
class LogDetail {
  constructor(Id, logId, name, newValue, oldValue) {
    (this.ID = Id),
      (this.LogID = logId),
      (this.Name = name),
      (this.NewValue = newValue),
      (this.OldValue = oldValue);
  }
}
export { EnqueueFinancialLog, EnqueueFullUser, EnqueueFrame, SetFullUser, EnqueueDelUser ,EnqueueUserLeave};
